<template>
  <!-- TODO: Thilo, one nice transition plz -->
  <basic-form
    v-if="open"
    class="container appearance-extended surface-alternative"
    :name="$props.formName"
    :validator="$props.v"
    @cancel="cancel"
    @submit="submit"
  >
    <span
      class="title-2"
      v-text="$props.title"
    />
    <div class="container__content">
      <div class="container__inputs">
        <slot />
      </div>
      <div class="container__message">
        <slot name="message" />
      </div>
      <div class="container__actions">
        <basic-button
          primary
          type="submit"
          :label="$t('form.apply')"
        />
        <basic-button
          hierarchy="secondary"
          type="cancel"
          :label="$t('form.cancel')"
        />
      </div>
    </div>
  </basic-form>
</template>

<script setup>
  import { BasicButton, BasicForm } from '@shared/components/Basic'

  // INIT
  const open = defineModel('open', { type: Boolean })
  const emit = defineEmits(['cancel', 'submit'])
  defineProps({
    formName: {
      type: String,
      required: true,
    },

    title: {
      type: String,
      required: true,
    },

    v: {
      type: Object,
      required: true,
    },
  })

  // METHODS
  function cancel() {
    open.value = false
    emit('cancel')
  }

  function submit() {
    // open.value = false
    emit('submit')
  }
</script>

<style scoped>
.container {
  background-color: var(--surface-ext-a);
  margin: var(--fixed-spacing-fix-06) 0 0;
  padding: var(--dotcom-responsive-spacing-res-s);
  border-radius: var(--fixed-border-radius-fix-03);
}

.container__content {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-areas:
    'inputs'
    'message'
    'actions';
  margin: var(--fixed-spacing-fix-03) 0 0;
}

.container__inputs {
  grid-area: inputs;
}

.container__message {
  grid-area: message;
  &:not(:empty) {
    margin: 0 0 var(--fixed-spacing-fix-06);
  }
}

.container__actions {
  grid-area: actions;
  display: flex;
  flex-direction: column;
  gap: var(--fixed-spacing-fix-04);
}

@media (--v-medium) {
  .container__actions {
    flex-direction: row-reverse;
    justify-content: flex-start;
  }
}

@media (--v-large) {
  .container__content {
    grid-template-columns: 1fr min-content;
    grid-template-areas:
      'inputs'
      'message'
      'actions';
  }

  .container__inputs {
    display: grid;
    grid-template-rows: 1fr 1fr;
    grid-template-columns: 1fr 1fr;
    gap: var(--fixed-spacing-fix-04);
  }

  .one-line-grid {
    .container__content {
      grid-template-areas:
        'inputs actions'
        'message message';
    }
    .container__inputs {
      display: grid;
      grid-template-columns: 1fr;
    }
  }

  .two-line-grid {
    .container__content {
      gap: var(--fixed-spacing-fix-03);
    }
    .container__inputs {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
  }
}
</style>
